"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmButton = void 0;
var React = require("react");
var ReducerTypes = require("@caddigital/sok-reducers/lib/types");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-ui/lib/utils/translation");
var ConfirmButton = function (props) {
    var localizationKey = props.listEntryType === ReducerTypes.TEMPLATE
        ? 'buttons/save'
        : 'management/reports/modal/buttons/confirmExport';
    return (React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)(localizationKey), iconRight: React.createElement(sok_ui_1.Icon, { className: 'fa-check-circle' }), color: 'base-blue', onClick: props.onClick, disabled: props.disabled }));
};
exports.ConfirmButton = ConfirmButton;
